import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, inject, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { Property, PropertyAvailability, UpdatePropertyAvailabilityRequest } from '../../../../../features/property/models/property.model';
import { ManagePropertyCalendar } from '../manage-property-calendar/manage-property-calendar';
import { AvailabilityService } from '../../../../../features/property/services/property-availability.service';
import { AuthService } from '../../../../../core/services/auth.service';
import { tap } from 'rxjs';
import { SnackBarService } from '../../../../services/snackbar.service';
import { HapticsService } from '../../../../general/services/haptics.service';

@Component({
  selector: 'app-update-property-booking-form',
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatFormFieldModule,
    MatSelectModule,
    MatDatepickerModule,
    FormsModule,
    MatInputModule,
    MatNativeDateModule,
    MatDialogModule
  ],
  templateUrl: './update-property-booking-form.html',
  styleUrl: './update-property-booking-form.scss',
})
export class UpdatePropertyBookingForm implements OnInit {
  private availabilityService = inject(AvailabilityService);
  private auth = inject(AuthService);
  private cdr = inject(ChangeDetectorRef);
  private haptics = inject(HapticsService);
  private snackbar = inject(SnackBarService);

  private readonly data = inject<number>(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<ManagePropertyCalendar, string>);
  username: string | null = null;
  availabilityId: number | undefined = undefined;
  property: Property | undefined = undefined;
  availability: PropertyAvailability | undefined = undefined;
  startDate: Date = new Date();
  endDate: Date = new Date();
  blockedReason: string | undefined = undefined;
  reason: string | undefined = undefined;
  reasons: string[] = ['Booked', 'Owner', 'Maintenance'];

  ngOnInit() {
    this.auth.loggedInUserId$.pipe(tap(result => this.username = result)).subscribe();
    this.availabilityId = this.data;
    console.log('AddPropertyBookingForm', this.availabilityId, this.dialogRef);
    this.loadPropertyAvailability();
  }

  loadPropertyAvailability() {
    if (this.availabilityId != undefined) {
      this.availabilityService.getPropertyAvailabilityById(this.availabilityId).pipe(tap(result => {
        console.log('Property Availability ', result);
        this.availability = result;
        this.startDate = new Date(result.date);
        this.reason = result.status ?? undefined;
        this.blockedReason = result.blockedReason ?? undefined;
        this.cdr.detectChanges();
      })).subscribe();
    }
  }

  onCancel() {
    this.haptics.click();
    console.log('cancel');
    this.dialogRef.close();
  }

  onSave() {
    this.haptics.click();
    console.log('save');
    if (this.availability != undefined && this.availabilityId != undefined) {
      const request: UpdatePropertyAvailabilityRequest = {
        status: this.reason,
        currency: 'USD',
        sourceUpdatedAt: new Date().toISOString(),
        blockedReason: this.blockedReason,
        syncedAt: new Date().toISOString()
      }

      this.availabilityService.updatePropertyAvailability(this.availabilityId, request).subscribe({
        next: () => {
          console.log(`Updated ${this.availabilityId}`);
          this.snackbar.open('Updated successfully', ' ', {
            duration: 5000,
            panelClass: ['success-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'top'
          });
          this.dialogRef.close();
        },
        error: err => {
          console.error(`Failed to update ${this.availabilityId}`, err);
          this.snackbar.open('There was problem updating the date. Please try again.', ' ', {
            duration: 5000,
            panelClass: ['error-snackbar'],
            horizontalPosition: 'center',
            verticalPosition: 'top'
          });
        }
      });
    }
  }
}
